module.exports = __webpack_public_path__ + "static/media/powered_by_aipass.e5efeea8.svg";